import { request } from '@/api/request'

export interface Environment {
  id: string
  customerId: string
  productId: string
  name: string
  kind: string
  isValidated: boolean
  product?: { id: string; key: string; name: string }
}

export interface Customer {
  id: string
  name: string
  slug: string
  status: string
  timeZone: string
  environments: Environment[]
  /** Active tenants (branches / sites), by name. */
  tenants?: Tenant[]
}

export interface Tenant {
  id: string
  name: string
  code: string
  timeZone: string
}

export interface Contact {
  id: string
  customerId: string
  /** The contact's branch (site) of the customer, if any. */
  tenantId: string | null
  email: string
  name: string
  role: string | null
}

export interface ProductComponent {
  id: string
  key: string
  name: string
}

export interface Product {
  id: string
  key: string
  name: string
  active: boolean
  components: ProductComponent[]
  keyPatterns?: { type: string; regex: string; normalizer?: string; urlTemplate?: string | null }[]
}

export interface Agent {
  id: string
  name: string
  initials: string
  email: string
  tier: number | null
  title: string | null
  team: string | null
}

export const directoryApi = {
  customers: (): Promise<Customer[]> => request<Customer[]>('/customers'),
  contacts: (customerId: string): Promise<Contact[]> =>
    request<Contact[]>(`/contacts?customerId=${encodeURIComponent(customerId)}`),
  products: (): Promise<Product[]> => request<Product[]>('/products'),
  agents: (): Promise<Agent[]> => request<Agent[]>('/users/agents'),
  /** `PATCH /contacts/:id` (contacts.manage, admin-audited). */
  updateContact: (id: string, input: { name?: string; role?: string }): Promise<Contact> =>
    request<Contact>(`/contacts/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(input) }),
}
